<!-- eslint-disable @angular-eslint/template/i18n -->
<div class="survey-modal-wrapper">
    <div class="survey-modal-header">
        <button class="button-undecorated" [attr.aria-label]="'Close Signing Modal'" (click)="closeSurveyModal()">
            <cwo-round-icon [iconName]="iconNameType.close" [size]="'medium'" />
        </button>
    </div>
    <p class="title">{{ "modals.survey.thanks_for_answer" | transloco }}</p>
    @if(siteEntries.length > 0) {
        <p class="message">{{ "modals.survey.we_are_so_happy" | transloco }}&nbsp;{{
            "modals.survey.please_consider_reviewing" | transloco
            }}
        </p>
        @for (site of siteEntries; track site.name) {
        <a [href]="getSafeUrl(site.url)" target="_blank" rel="noopener noreferrer">
            <cwo-text-button 
                [iconName]="site.icon" 
                [iconSize]="'2rem'" 
                [iconPosition]="'left'"
                [ariaLabel]="site.name + ' Review'" 
                [color]="'var(--text)'" 
                [fontWeight]="'var(--font-weight-bold)'"
                [padding]="'0.5rem 2rem'" 
                [class]="site.name === 'Facebook' ? 'larger-svg' : ''"
                [borderColor]="'var(--text)'">
                
                <span class="text-button-content">
                    {{ site.name }}
                </span>
            </cwo-text-button>
        </a>
        }
    }
    <div class="divider"></div>
    <button class="button-accent action-button" (click)="backToMenu()">
        {{'modals.survey.go_to_main_page' | transloco}}
    </button>
</div>